import { ArticleOutlined } from "@mui/icons-material";
import { useModals } from "../../../components/common/useModals";
import {
  createViewAction,
  formatCurrency,
  formatDateTime,
} from "../../../utils/helpers";
import { Tag } from "antd";
import { FormActions } from "../../../components/common/FormActions";
import { URL_FLOAT_INTEREST_STATEMENTS } from "../../../utils/urls";

const url = URL_FLOAT_INTEREST_STATEMENTS;

const useFloatInterestStatements = () => {
  const { setOpenInterestStatement } = useModals();

  const tableColumns = () => [
    {
      id: "config_name",
      header: "Config Name",
      filter: {
        type: "text",
      },
    },
    {
      id: "period_start",
      header: "Period Start",
      filter: {
        type: "date",
      },
    },
    {
      id: "period_end",
      header: "Period End",
      filter: {
        type: "date",
      },
    },
    {
      id: "base_amount",
      header: "Base Amount",
    },
    {
      id: "gross_interest_amount",
      header: "Gross Interest",
    },
    {
      id: "distributable_interest_amount",
      header: "Distributable Interest",
    },
    {
      id: "status",
      header: "Status",
      filter: {
        type: "select",
        options: [
          { label: "Posted", value: "POSTED" },
          { label: "Pending", value: "PENDING" },
          { label: "Failed", value: "FAILED" },
        ],
      },
    },
    {
      id: "posting_reference",
      header: "Posting Reference",
    },
    {
      id: "created_at",
      header: "Created At",
    },
    {
      id: "actions",
      header: "Actions",
    },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        base_amount: formatCurrency(item?.base_amount),
        gross_interest_amount: formatCurrency(item?.gross_interest_amount),
        distributable_interest_amount: formatCurrency(
          item?.distributable_interest_amount,
        ),
        status: (
          <Tag color={item?.status === "POSTED" ? "green" : "orange"}>
            {item?.status}
          </Tag>
        ),
        created_at: formatDateTime(item?.created_at),
        actions: <FormActions actions={[createViewAction(url, item?.id)]} />,
      };
    }),
  ];

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Statement Details",
          fields: {
            config_name: item?.config_name,
            period_start: item?.period_start,
            period_end: item?.period_end,
            status: item?.status,
            posting_reference: item?.posting_reference,
            posted_at: formatDateTime(item?.posted_at),
            posting_error: item?.posting_error,
          },
        },
        {
          title: "Balance & Amounts",
          fields: {
            escrow_balance_snapshot: formatCurrency(
              item?.escrow_balance_snapshot,
            ),
            base_amount: formatCurrency(item?.base_amount),
            gross_interest_amount: formatCurrency(item?.gross_interest_amount),
            telecom_fee_amount: formatCurrency(item?.telecom_fee_amount),
            distributable_interest_amount: formatCurrency(
              item?.distributable_interest_amount,
            ),
          },
        },
        {
          title: "Revenue Sharing Rates",
          fields: {
            annual_interest_rate: item?.annual_interest_rate,
            telecom_fee_rate: item?.telecom_fee_rate,
            boa_share_rate: item?.boa_share_rate,
            onepayx_share_rate: item?.onepayx_share_rate,
          },
        },
        {
          title: "Distribution Amounts",
          fields: {
            boa_share_amount: formatCurrency(item?.boa_share_amount),
            onepayx_share_amount: formatCurrency(item?.onepayx_share_amount),
          },
        },
        {
          title: "Metadata",
          fields: {
            created_at: formatDateTime(item?.created_at),
            created_by: item?.created_by,
            config: item?.config,
          },
        },
      ],
    };
  };

  const customActions = [
    {
      label: "Process Float Interest Statement",
      icon: <ArticleOutlined />,
      type: "default",
      onClick: () => {
        setOpenInterestStatement();
      },
      props: {},
    },
  ];

  return { tableColumns, tableData, viewData, customActions };
};

export default useFloatInterestStatements;
